import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  cameFromOptions: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    position: 'relative',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  previousStepButton: {
    padding: theme.spacing(9.75, 4),
    marginBottom: theme.spacing(10),
  },
  previousStepButtonLabel: {
    fontSize: theme.spacing(8),
    lineHeight: '18px',
    fontWeight: 'normal',
    textTransform: 'capitalize',

    [theme.breakpoints.down('md')]: {
      fontSize: theme.spacing(7),
      lineHeight: '14px',
    },
    [theme.breakpoints.down('sm')]: {
      lineHeight: '12px',
    },
  },
  cameFromOptionsError: {
    position: 'absolute',
    bottom: theme.spacing(4),
  },
}));
